import {
  Grid,
  InputAdornment,
  TextField,
} from '@mui/material'
import React from 'react'

const BatchExpiry = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <TextField
      label="Batch / Expiry"
      fullWidth
      value={moduleValues['Batch / Expiry']}
      onChange={(e) =>
        setModuleValues((prev) => ({ ...prev, ['Batch / Expiry']: e.target.value }))
      }
    />
  </Grid>
)

export default BatchExpiry
